import buildEvent from './pipeline/build';
import formatEvent from './pipeline/format';
import validateEvent from './schema';

export interface ReturnResult {
  error: any;
  value?: undefined | null;
}

export const createEvents = (events: any[]) => {
  // console.log('createEvents', events);
  if (!events) {
    return { error: Error('one argument is required'), value: null };
  }

  if (events.length === 1) {
    return createEvent(events[0]);
  }
  const { error, value } = events
    .map(validateAndBuildEvent)
    .map(applyInitialFormatting)
    .map(reformatEventsByPosition)
    .reduce(catenateEvents, { error: null, value: null });

  return { error, value };
};

// const createEvent = (event: any) => {};

function reformatEventsByPosition({ error, value }, idx, list) {
  if (error) return { error, value };

  if (idx === 0) {
    // beginning of list
    return { value: value.slice(0, value.indexOf('END:VCALENDAR')), error: null };
  }

  if (idx === list.length - 1) {
    // end of list
    return { value: value.slice(value.indexOf('BEGIN:VEVENT')), error: null };
  }

  return { error: null, value: value.slice(value.indexOf('BEGIN:VEVENT'), value.indexOf('END:VEVENT') + 12) };
}

function catenateEvents(accumulator, { error, value }, idx) {
  if (error) {
    accumulator.error = error;
    accumulator.value = null;
    return accumulator;
  }

  if (accumulator.value) {
    accumulator.value = accumulator.value.concat(value);
    return accumulator;
  }

  accumulator.value = value;
  return accumulator;
}
function validateAndBuildEvent(event) {
  return validateEvent(buildEvent(event));
}

export function convertTimestampToArray(timestamp: string) {
  // console.log('convertTimestampToArray', { timestamp });
  const dateArray = [];
  // 2023-02-26T06:00:00-05:00
  dateArray.push(+timestamp.substring(0, 4));
  dateArray.push(+timestamp.substring(5, 7));
  dateArray.push(+timestamp.substring(8, 10));
  dateArray.push(+timestamp.substring(11, 13));
  dateArray.push(+timestamp.substring(14, 16));
  dateArray.push(+timestamp.substring(17, 19));

  // console.log('convertTimestampToArray dateArray', { timestamp, dateArray });
  return dateArray;
}

export function createEvent(attributes, cb = null) {
  // console.log('createEvent', { attributes });
  if (!attributes) {
    Error('Attributes argument is required');
  }

  // assignUniqueId(attributes)

  if (!cb) {
    // No callback, so return error or value in an object
    const { error, value } = validateAndBuildEvent(attributes);

    if (error) return { error, value };

    let event = '';
    try {
      event = formatEvent(value);
    } catch (error) {
      return { error, value: null };
    }

    return { error: null, value: event };
  }

  // Return a node-style callback
  const { error, value } = validateAndBuildEvent(attributes);

  if (error) return { error };

  return { error: null, value: formatEvent(value) };
}

const applyInitialFormatting = ({ error, value }): ReturnResult => {
  if (error) {
    return { error, value: null };
  }

  return { error: null, value: formatEvent(value) };
};
